import { useNavigate, useLocation } from 'react-router-dom';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeIcon from '@mui/icons-material/Home';
import AddIcon from '@mui/icons-material/Add';
import ListIcon from '@mui/icons-material/ListAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BarChartIcon from '@mui/icons-material/BarChart';
import GroupsIcon from '@mui/icons-material/Groups';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import { alpha } from '@mui/material/styles';

export default function MobileBottomNav({ userRole }) {
  const navigate = useNavigate();
  const location = useLocation();

  const getNavItems = () => {
    const baseItems = [
      { label: 'Acasă', icon: <HomeIcon />, path: '/dashboard' },
    ];

    if (userRole === 'elev') {
      return [
        ...baseItems,
        { label: 'Cerere', icon: <AddIcon />, path: '/new-request' },
        { label: 'Listă', icon: <ListIcon />, path: '/my-requests' },
        { label: 'Sugestii', icon: <LightbulbIcon />, path: '/suggestions' },
      ];
    }

    if (userRole === 'profesor') {
      return [
        ...baseItems,
        { label: 'Elevi', icon: <GroupsIcon />, path: '/teacher-students' },
        { label: 'Validare', icon: <CheckCircleIcon />, path: '/review-requests' },
      ];
    }

    if (userRole === 'coordonator') {
      return [
        ...baseItems,
        { label: 'Validare', icon: <CheckCircleIcon />, path: '/review-requests' },
        { label: 'Statistici', icon: <BarChartIcon />, path: '/overview' },
      ];
    }

    return baseItems;
  };

  const navItems = getNavItems();
  const currentIndex = navItems.findIndex(item => location.pathname === item.path);

  return (
    <BottomNavigation
      showLabels
      value={currentIndex !== -1 ? currentIndex : 0}
      onChange={(event, newValue) => {
        navigate(navItems[newValue].path);
      }}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid',
        borderColor: alpha('#4F46E5', 0.1),
        zIndex: 1000,
        height: 70,
        boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.05)',
        '& .MuiBottomNavigationAction-root': {
          minWidth: 'auto',
          padding: '8px 0',
          color: '#000000',
          transition: 'all 0.2s ease',
          '&.Mui-selected': {
            color: '#4F46E5',
          },
          '& .MuiSvgIcon-root': {
            fontSize: '1.5rem',
            transition: 'transform 0.2s ease',
          },
          '&.Mui-selected .MuiSvgIcon-root': {
            transform: 'scale(1.1)',
          },
        },
        '& .MuiBottomNavigationAction-label': {
          fontSize: '0.7rem',
          fontWeight: 500,
          marginTop: '4px',
          transition: 'all 0.2s ease',
          '&.Mui-selected': {
            fontSize: '0.72rem',
            fontWeight: 600,
          },
        },
      }}
    >
      {navItems.map((item, index) => (
        <BottomNavigationAction
          key={index}
          label={item.label}
          icon={item.icon}
        />
      ))}
    </BottomNavigation>
  );
}